import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type {
  PortalInviteTemplateDto,
  CreatePortalInviteTemplateDto,
  UpdatePortalInviteTemplateDto,
  PortalInviteMergeFieldDto,
} from '~/swagger/settings/Api';

const PORTAL_INVITE_TEMPLATES_URL = `${envConfig.service.settings}/company-portal/settings/tenant-portal-invite-templates`;

export class PortalInviteTemplateRepository extends BaseRestRepository {
  public getTemplates = async (): Promise<PortalInviteTemplateDto[]> => {
    const response = await this.fetchWithAuth(PORTAL_INVITE_TEMPLATES_URL);
    return this.getJsonResponse(response);
  };

  public createTemplate = async (payload: CreatePortalInviteTemplateDto): Promise<PortalInviteTemplateDto> => {
    const response = await this.fetchWithAuth(PORTAL_INVITE_TEMPLATES_URL, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  };

  public updateTemplate = async (id: string, payload: UpdatePortalInviteTemplateDto): Promise<PortalInviteTemplateDto> => {
    const response = await this.fetchWithAuth(`${PORTAL_INVITE_TEMPLATES_URL}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  };

  public deleteTemplate = async (id: string): Promise<void> => {
    await this.fetchWithAuth(`${PORTAL_INVITE_TEMPLATES_URL}/${id}`, { method: 'DELETE' });
  };

  public resetTemplate = async (id: string): Promise<PortalInviteTemplateDto> => {
    const response = await this.fetchWithAuth(`${PORTAL_INVITE_TEMPLATES_URL}/${id}/reset`, { method: 'POST' });
    return this.getJsonResponse(response);
  };

  public getMergeFields = async (): Promise<PortalInviteMergeFieldDto[]> => {
    const url = `${PORTAL_INVITE_TEMPLATES_URL}/merge-fields`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  };
}

export const portalInviteTemplateRepository = new PortalInviteTemplateRepository();
